import React, { Component, Fragment } from "react"
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import moment from "moment"
import { confirmAlert } from "react-confirm-alert";
import {
  StyleServices,
  DevelopmentServices
} from "../../services"
import printer from "../../assets/images/printer.png"

import Async from "react-select"
//components
import Field from "../../components/Common/Field/Field"
import PageHeader from "../../components/Page/PageHeader/PageHeader"
import { connect } from "react-redux"
import PrintSmv from "./printSmv"
import Button from "../../components/Buttons/Button"
import ButtonIcon from "../../components/Costing/Button/ButtonIcon"
import Loading from "../../components/Common/Loading"

//services
import { getFixedTwo } from "../../services/utility.service"

const smvDataTemplate = {
  operations: null,
  machine: null,
  folder: null,
  seconds: null,
  SAM: null,
  targetPerHour: null
}

const threadConsumptionTemplate = {
  operations: null,
  machine: null,
  length: null,
  factor: null,
  rating: null,
  total: null,
  needle: null,
  looper: null,
  overLock: null,
  trimThread: null,
  sheeringNeedle: null
  // threadElastic: "",
}

class SmvThread extends Component {
  state = {
    //header title
    header: "SMV/OB and Thread Consumption",
    action: "",
    _id: "",
    threadId: "",
    active: false,
    disabled: false,
    smvNumber: null,
    magnumStyleId: null,
    styleReferenceId: null,
    sampleType: null,
    sampleDate: null,
    size: "",
    chartPreparedOn: null,
    chartPreparedBy: this.props.chartPreparedBy,
    smvdata: [],
    totalSam: null,
    targetSAM: null,
    "100Target": null,
    "80Target": null,
    minutesPerDay: 480,
    sizes: null,
    customer: null,
    customerDepartmentId: null,

    //thread Consumption
    threadData: [],
    wash: null,
    wastage: null,
    otherSizes: null,
    totalLooper: null,
    totalLooperRound: null,
    totalNeedle: null,
    totalNeedleRound: null,

    magnumStyleName: "",
    customerName: "",
    departmentName: "",
    smvId: "",
    styleNoInfo: [],

    amendmentNumber: null,

    allSizes: [],
    prefillInfo: {
      MACHINE: [],
      OPERATION: [],
      SAMPLETYPE: [],
      OTHERS: {}
    },
    readOnlyClass: false,
    dragIndex: 0,
    dropIndex: 0,
    printLoading: false,
    threadCreated: false,
    isLoading: false,
    smvObData: {},

    styleNo: "",
    sampleLabel: "",
    totalVal: "",
    totalNeedle: "",
    totalLooper: "",
    totalOverLock: "",
    totalSheeringNeedle: "",
    totalTrimThread: "",
    totalNeedleRound: "",
    totalLooperRound: "",
    totalOverLockRound: "",
    totalSheeringNeedleRound: "",
    totalTrimThreadRound: "",
    selectedsize: ""


  }

  async componentWillMount() {
    await this.setState({
      isLoading: true
    })
    const { styleReferenceId, action, _id, smvId } = this.props.location.state
    if (styleReferenceId !== "") {
      await this.getMagnumStyleNo("")
      await this.setState({
        styleReferenceId
      })
      setTimeout(async () => {
        await this.getStyleReferenceInfo(styleReferenceId)
      }, 200)
    }

    if (action == "edit") {
      await this.setState({
        readOnlyClass: true
      })
    }

    if (action == "add") {
      await this.setState({
        sampleDate: new Date(),
        chartPreparedOn: new Date(),
        firstName: this.props.firstName,
        lastName: this.props.lastName
      })
    }
    if (action == "view") {
      await this.setState({
        disabled: true
      })
    }

    if (action == "view" || action == "edit") {
      if (_id != "" && smvId !== "") {
        await StyleServices.getSMV(smvId)
          .then(response => {
            if (response.status == 200) {
              let hundredtarget = response.text.data["100Target"]
                ? response.text.data["100Target"]
                : null
              let eightytarget = response.text.data["80Target"]
                ? response.text.data["80Target"]
                : null
              let amendmentNumber = response.text.data.amendmentNumber
                ? response.text.data.amendmentNumber
                : null
              let firstName =
                Object.keys(response.text.data.chartPreparedBy).length > 0
                  ? response.text.data.chartPreparedBy.firstName
                  : ""
              let lastName =
                Object.keys(response.text.data.chartPreparedBy).length > 0
                  ? response.text.data.chartPreparedBy.lastName
                  : ""
              let chartPreparedBy =
                Object.keys(response.text.data.chartPreparedBy).length > 0
                  ? response.text.data.chartPreparedBy._id
                  : ""
              let chartPreparedOn = response.text.data.chartPreparedOn
                ? response.text.data.chartPreparedOn
                : null
              let customer = response.text.data.customer
                ? response.text.data.customer
                : null
              let customerDepartmentId = response.text.data.customerDepartmentId
                ? response.text.data.customerDepartmentId
                : null
              let smvdata =
                response.text.data.data.length > 0
                  ? [...response.text.data.data]
                  : this.state.smvdata
              let magnumStyleId = response.text.data.magnumStyleId
                ? response.text.data.magnumStyleId
                : null
              let minutesPerDay = response.text.data.minutesPerDay
                ? response.text.data.minutesPerDay
                : null
              let sampleType = response.text.data.sampleType
                ? response.text.data.sampleType
                : null
              let size = response.text.data.size
                ? response.text.data.size
                : null
              let styleReferenceId = response.text.data.styleReferenceId
                ? response.text.data.styleReferenceId
                : null
              let totalSam = response.text.data.totalSam
                ? response.text.data.totalSam
                : null
              let smvNumber = response.text.data.smvNumber
                ? response.text.data.smvNumber
                : null
              if (styleReferenceId !== null || styleReferenceId !== "") {
                this.getStyleReferenceInfo(styleReferenceId)
                this.getMagnumStyleById(styleReferenceId)
              }

              this.setState({
                ["100Target"]: hundredtarget,
                ["80Target"]: eightytarget,
                amendmentNumber,
                firstName,
                lastName,
                chartPreparedBy,
                chartPreparedOn,
                customer,
                customerDepartmentId,
                smvdata,
                magnumStyleId,
                minutesPerDay,
                sampleDate: response.text.data.sampleDate,
                sampleType,
                size,
                styleReferenceId,
                totalSam,
                smvNumber
              })
            }
          })
          .catch(error => this.props.getalertMessage("error", error.toString()))
        await StyleServices.getSpecificThread(_id)
          .then(response => {
            if (response.status == 200) {
              let threadId = response.text.data._id
              let threadData =
                response.text.data.data.length > 0
                  ? [...response.text.data.data]
                  : [...this.state.threadData]
              let smvId = response.text.data.smvId
                ? response.text.data.smvId
                : ""
              let totalLooper = response.text.data.totalLooper
                ? response.text.data.totalLooper
                : null
              let totalLooperRound = response.text.data.totalLooperRound
                ? response.text.data.totalLooperRound
                : null
              let totalNeedle = response.text.data.totalNeedle
                ? response.text.data.totalNeedle
                : null
              let totalNeedleRound = response.text.data.totalNeedleRound
                ? response.text.data.totalNeedleRound
                : null
              let wash = response.text.data.wash
                ? response.text.data.wash
                : null
              let wastage = response.text.data.wastage
                ? response.text.data.wastage
                : null
              let otherSizes = response.text.data.otherSizes
                ? response.text.data.otherSizes
                : null
              let sizes = response.text.data.allSizes
                ? response.text.data.allSizes
                : null

              //

              let totalOverLock = response.text.data.totalOverLock
                ? response.text.data.totalOverLock
                : null
              let totalOverLockRound = response.text.data.totalOverLockRound
                ? response.text.data.totalOverLockRound
                : null
              let totalSheeringNeedle = response.text.data.totalSheeringNeedle
                ? response.text.data.totalSheeringNeedle
                : null
              let totalSheeringNeedleRound = response.text.data
                .totalSheeringNeedleRound
                ? response.text.data.totalSheeringNeedleRound
                : null
              let totalTrimThread = response.text.data.totalTrimThread
                ? response.text.data.totalTrimThread
                : null
              let totalTrimThreadRound = response.text.data.totalTrimThreadRound
                ? response.text.data.totalTrimThreadRound
                : null
              this.setState({
                threadData,
                smvId,
                threadId,
                totalLooper,
                totalLooperRound,
                totalNeedle,
                totalNeedleRound,
                wash,
                wastage,
                otherSizes,
                sizes,
                totalOverLock,
                totalOverLockRound,
                totalSheeringNeedle,
                totalSheeringNeedleRound,
                totalTrimThread,
                totalTrimThreadRound
              })
            }
          })
          .catch(error => this.props.getalertMessage("error", error.toString()))
      }
    }

    await this.setState({
      action,
      _id,
      smvId
    })
    await this.systemValues()
    await this.setState({
      isLoading: false
    })
  }
  handleActive = () => {
    let active = this.state.active;
    this.setState({
      active: !active
    })
  }
  componentDidMount() {
    const { action } = this.props.location.state
    if (action === "edit" || action === "view") {
      setTimeout(() => {
        this.calcForTotal()
      }, 1500)
    }
    if (this.state.action === "add") {
      window.addEventListener("beforeunload", function (event) {
        event.returnValue = "Hellooww"
      })
    }
  }
  componentWillUnmount() {
    if (this.state.action === "add") {
      window.removeEventListener("beforeunload", function (event) {
        event.returnValue = "Hellooww"
      })
    }
  }
  //list smv system master
  systemValues = () => {
    StyleServices.prefillSMVInfo()
      .then(response => {
        if (response.status == 200) {
          response.text.data.MACHINE = response.text.data.MACHINE.map(data => {
            let dat = { ...data }
            dat.label = data.name
            dat.value = data._id
            return dat

          })
          this.setState({

            prefillInfo: response.text.data,
            wash:
              this.state.wash === null
                ? Number(response.text.data.OTHERS.wash)
                : Number(this.state.wash),
            otherSizes:
              this.state.otherSizes == null
                ? Number(response.text.data.OTHERS.otherSize)
                : Number(this.state.otherSizes),
            wastage:
              this.state.wastage == null
                ? Number(response.text.data.OTHERS.wastage)
                : Number(this.state.wastage)
          })
        } else if (response.status == 401) {
          this.props.unauthorisedFunc()
        } else {
          this.props.getalertMessage("error", response.text.message)
        }
      })
      .catch(error => this.props.getalertMessage("error", error.toString()))
  }

  // list and search style reference

  getMagnumStyleNo = value => {
    DevelopmentServices.getMagnumStyleNoWithReference(value)
      .then(response => {
        if (response.status === 200) {
          let jsonData = []
          response.text.data.map((info, index) => {
            let objData = {}
            objData.label = info.referenceCode
            objData.value = info.referenceId
            jsonData.push(objData)
          })
          this.setState({ styleNoInfo: jsonData })
        }
      })
      .catch(error => this.props.getalertMessage("error", error.toString()))
  }

  //style select
  getStyleReferenceInfo = styleReferenceId => {
    if (styleReferenceId !== null) {
      styleReferenceId =
        typeof styleReferenceId == "object"
          ? styleReferenceId.value
          : styleReferenceId
      StyleServices.getStyleInfoByReference(styleReferenceId)
        .then(response => {
          if (response.status === 200) {
            this.setState(
              {
                magnumStyleName: response.text.data.magnumStyleName,
                magnumStyleId: response.text.data.magnumStyleId,
                customer:
                  response.text.data.customer !== ""
                    ? response.text.data.customer
                    : null,
                customerDepartmentId: response.text.data.customerDepartmentId,
                customerName: response.text.data.customerName,
                departmentName: response.text.data.departmentName,
                styleReferenceId
              },
              () => this.getMagnumStyleById(styleReferenceId),
              this.getSMVCustomerData(
                response.text.data.customer,
                response.text.data.customerDepartmentId
              )
            )
          }
          response.status == 401 && this.props.unauthorisedFunc()
        })
        .catch(error => this.props.getalertMessage("error", error.toString()))
    } else {
      this.setState(
        {
          styleReferenceId: null,
          customer: null,
          customerDepartmentId: null,
          customerName: "",
          departmentName: "",
          magnumStyleId: null,
          magnumStyleName: ""
        },
        () => this.getMagnumStyleNo("")
      )
    }
  }

  getMagnumStyleById = value => {
    DevelopmentServices.getMagnumStyleNoWithReferenceById(value)
      .then(response => {
        if (response.status === 200) {
          let styleNoInfo = []
          response.text.data.map(data => {
            if (data !== null) styleNoInfo.push({ ...data })
          })
          this.setState({ styleNoInfo })
        }
      })
      .catch(error => this.props.getalertMessage("error", error.toString()))
  }

  getSMVCustomerData = (customer, customerDepartmentId) => {
    StyleServices.getSMVCustomerData(customer, customerDepartmentId)
      .then(response => {
        if (response.status == 200) {
          this.setState({
            allSizes: response.text.data.allSizes
          })
        } else if (response.status == 401) {
          this.props.unauthorisedFunc()
        } else {
          this.props.getalertMessage("error", response.text.message)
        }
      })
      .catch(error => this.props.getalertMessage("error", error.toString()))
  }

  /*****************************************************************************/

  // SMB & CALC func start

  addSmv = () => {
    let smvdata = [...this.state.smvdata]
    let threadData = [...this.state.threadData]
    smvdata.push({ ...smvDataTemplate })
    threadData.push({ ...threadConsumptionTemplate })
    this.setState({ smvdata, threadData })
  }

  removeSmv = index => {
    if (this.state.smvdata.length > 0 && this.state.threadData.length > 0) {
      let smvdata = [...this.state.smvdata]
      let threadData = [...this.state.threadData]
      smvdata.splice(index, 1)
      threadData.splice(index, 1)
      this.setState({ smvdata, threadData },
        () => {
          this.updateCalcForSAM(), threadData.length ?
            this.updateValuesforThreadCons("length", threadData[threadData.length - 1].length, threadData.length - 1) :
            this.calcForTotal()
        }
      )
    }
  }

  _onDragStart = (e, index) => {
    this.setState({ dragIndex: index })
  }

  _onDragOver = event => {
    event.stopPropagation()
    event.preventDefault()
  }

  _onDropEnd = (e, index) => {
    // this.setState({ dropIndex: index })
    // let smvdata = [...this.state.smvdata]
    // let count = [...smvdata]
    // let tmp = { ...this.state.smvdata[this.state.dragIndex] }
    // count[this.state.dragIndex] = { ...count[index] }
    // count[index] = { ...tmp }
    // smvdata = count
    // this.setState({
    //   smvdata
    // })

    // let threadData = [...this.state.threadData]
    // let tmp1 = threadData[this.state.dragIndex]
    // threadData[this.state.dragIndex] = threadData[index]
    // threadData[index] = tmp1
    // this.setState({ threadData })

    let iData = [...this.state.smvdata].find((x, i) => this.state.dragIndex == i)
    let filterData = [...this.state.smvdata].filter((x, i) => this.state.dragIndex != i)
    filterData.splice(index, 0, iData)

    let itData = [...this.state.threadData].find((x, i) => this.state.dragIndex == i)
    let tfilterData = [...this.state.threadData].filter((x, i) => this.state.dragIndex != i)
    tfilterData.splice(index, 0, itData)

    this.setState({
      smvdata: filterData,
      threadData: tfilterData
    })
  }

  updateValueSmvCalc = (name, value, index) => {
    let smvdata = [...this.state.smvdata]
    smvdata[index][name] = value
    this.setState({
      smvdata
    })
  }

  updateValueForRowdata = (name, value, index) => {
    let data = [...this.state.smvdata]
    data[index][name] = value
    if (name === "operations" || name === "machine") {
      let threadData = [...this.state.threadData]
      threadData[index][name] = value
      if (name == "machine") {
        this.state.prefillInfo.MACHINE.map(data => {
          if (data.value == value) {
            // threadData[index].length = Number(data.length);
            // threadData[index].factor = Number(data.factor);
            threadData[index].needle = Number(data.needle)
            threadData[index].looper = Number(data.looper)
            // Need to change in data.factor as data.rating, after backend is fixed
            threadData[index].rating = Number(data.factor)
            threadData[index].sheeringNeedle = Number(data.sheeringNeedle)
            threadData[index].overLock = Number(data.overLock)
            threadData[index].trimThread = Number(data.trimThread)
          }
        })
      }
      this.setState({ threadData })
    }

    this.setState(
      {
        smvdata: data
      },
      () => this.updateCalcForSAM()
    )
  }

  updateCalcForSAM = () => {
    let smvdata = [...this.state.smvdata]
    let totalSam = 0
    smvdata = smvdata.map(data => {
      if (data.seconds !== null) {
        data.SAM = (Number(data.seconds) / 60).toFixed(2)
        data.targetPerHour = (60 / Number(data.SAM)).toFixed(2)
      } else {
        data.SAM = 0
        data.TargetPerHour = 0
      }
      if (data.SAM !== null) {
        totalSam = (Number(totalSam) + Number(data.SAM)).toFixed(2)
      } else {
        totalSam = 0
      }
      return data
    })
    this.setState(
      {
        smvdata,
        totalSam
      },
      () => this.updateCalcForSMV()
    )
  }

  updateCalcForSMV = () => {
    if (this.state.totalSam !== null) {
      let hundredtarget = Math.round(
        Number(this.state.minutesPerDay) / Number(this.state.totalSam)
      ).toFixed(2)
      let eightytarget = Math.round(hundredtarget * (80 / 100)).toFixed(2)
      this.setState({
        ["100Target"]: hundredtarget,
        ["80Target"]: eightytarget
      })
    }
  }

  createSMV = (duplicate) => {
    if (!this.state.magnumStyleId)
      return this.props.getalertMessage("error", "Please select Style Options")

    this.setState({ isLoading: true })
    let smv = {}
    smv.sampleType = this.state.sampleType
    smv.sampleDate = duplicate ? new Date() : this.state.sampleDate
    smv.magnumStyleId = this.state.magnumStyleId
    smv.styleReferenceId = this.state.styleReferenceId
    smv.size = this.state.size
    smv.chartPreparedOn = duplicate ? new Date() : this.state.chartPreparedOn
    smv.chartPreparedBy = this.state.chartPreparedBy
    smv.data = [...this.state.smvdata]
    smv.totalSam = this.state.totalSam
    smv.minutesPerDay = this.state.minutesPerDay
    smv["100Target"] = this.state["100Target"]
    smv["80Target"] = this.state["80Target"]
    smv.customer = this.state.customer
    smv.customerDepartmentId = this.state.customerDepartmentId
    if (this.state._id && !duplicate) {
      smv.smvId = this.state.smvId
      smv._id = this.state._id
    }

    StyleServices.createSMV(smv)
      .then(response => {
        if (response.status === 200) {
          this.props.getalertMessage("success", response.text.message)
          this.setState({
            readOnlyClass: !duplicate ? true : false,
            smvId: response.text.data._id,
            _id: response.text.data.threadId,
            threadId: response.text.data.threadId,
            smvNumber: response.text.data.smvNumber,
            isLoading: false
          })
          this.createThread()
        } else if (response.status == 401) {
          this.props.unauthorisedFunc()
        } else {
          this.setState({ isLoading: false })
          this.props.getalertMessage("error", response.text.message)
        }
      })
      .catch(error => {
        this.setState({ isLoading: false })
        this.props.getalertMessage("error", error.toString())
      })
  }

  // SMV & CALC func end
  /*****************************************************************************/

  /**************************************************************************** */

  //Thread func start

  updateValuesforThreadCons = (name, value, index) => {
    if (name !== "thread") {
      value = Number(value)
    }

    const threadData = [...this.state.threadData].map(x => {
      // x.machine = isNaN(x.machine) ? x.machine : parseInt(x.machine);
      x.length = isNaN(x.length) ? x.length : parseFloat(x.length)
      x.factor = isNaN(x.factor) ? x.factor : parseFloat(x.factor)
      x.rating = isNaN(x.rating) ? x.rating : parseFloat(x.rating)
      x.total = isNaN(x.total) ? x.total : parseInt(x.total)
      x.needle = isNaN(x.needle) ? x.needle : parseInt(x.needle)
      x.looper = isNaN(x.looper) ? x.looper : parseInt(x.looper)
      x.overLock = isNaN(x.overLock) ? x.overLock : parseInt(x.overLock)
      x.trimThread = isNaN(x.trimThread) ? x.trimThread : parseInt(x.trimThread)
      return x
    })
    threadData[index][name] = isNaN(value) ? value : Number(value)

    this.setState(
      {
        threadData
      },
      () => this.calcForTotal()
    )
  }

  calcForTotal = () => {
    let threadData = [...this.state.threadData].map(x => {
      // x.machine = isNaN(x.machine) ? 0 : parseInt(x.machine);
      x.length = isNaN(x.length) ? 0 : parseInt(x.length)
      x.factor = isNaN(x.factor) ? 0 : parseInt(x.factor)
      x.rating = isNaN(x.rating) ? 0 : parseFloat(x.rating)
      x.total = isNaN(x.total) ? 0 : parseInt(x.total)
      x.needle = isNaN(x.needle) ? 0 : parseInt(x.needle)
      x.looper = isNaN(x.looper) ? 0 : parseInt(x.looper)
      x.overLock = isNaN(x.overLock) ? 0 : parseInt(x.overLock)
      x.trimThread = isNaN(x.trimThread) ? 0 : parseInt(x.trimThread)
      return x
    })

    let totalVal = null
    let totalNeedle = null
    let totalLooper = null
    let totalOverLock = null
    let totalSheeringNeedle = null
    let totalTrimThread = null
    let totalNeedleRound = null
    let totalLooperRound = null
    let totalOverLockRound = null
    let totalSheeringNeedleRound = null
    let totalTrimThreadRound = null
    const TPERCENT = (Number(this.state.wash) + Number(this.state.wastage) + Number(this.state.otherSizes))
    threadData = threadData.map(thread => {
      if (
        thread.length !== null &&
        thread.factor !== null &&
        thread.rating !== null &&
        thread.trimThread !== null &&
        thread.overLock !== null &&
        thread.sheeringNeedle !== null
      ) {
        thread.total =
          getFixedTwo(
            (Number(thread.length) + 5) *
            Number(thread.factor) *
            Number(thread.rating)
          ) / 100
        totalVal = getFixedTwo(Number(totalVal) + Number(thread.total))
        totalNeedle = getFixedTwo(
          Number(totalNeedle) +
          Number(thread.total) * (Number(thread.needle) / 100)
        )
        totalLooper = getFixedTwo(
          Number(totalLooper) +
          Number(thread.total) * (Number(thread.looper) / 100)
        )
        totalOverLock = getFixedTwo(
          Number(totalOverLock) +
          Number(thread.total) * (Number(thread.overLock) / 100)
        )
        totalSheeringNeedle = getFixedTwo(
          Number(totalSheeringNeedle) +
          Number(thread.total) * (Number(thread.sheeringNeedle) / 100)
        )
        totalTrimThread = getFixedTwo(
          Number(totalTrimThread) +
          Number(thread.total) * (Number(thread.trimThread) / 100)
        )
        totalNeedleRound = Math.round(
          Number(totalNeedle) + (Number(totalNeedle) * TPERCENT / 100)
        )
        totalLooperRound = Math.round(
          Number(totalLooper) + (Number(totalLooper) * TPERCENT / 100)
        )
        totalOverLockRound = Math.round(
          Number(totalOverLock) + (Number(totalOverLock) * TPERCENT / 100)
        )
        totalSheeringNeedleRound = Math.round(
          Number(totalSheeringNeedle) + (Number(totalSheeringNeedle) * TPERCENT / 100)
        )
        totalTrimThreadRound = Math.round(
          Number(totalTrimThread) + (Number(totalTrimThread) * TPERCENT / 100)
        )
      }
      return thread
    })
    this.setState({
      threadData,
      totalVal,
      totalNeedle,
      totalLooper,
      totalOverLock,
      totalSheeringNeedle,
      totalTrimThread,
      totalNeedleRound,
      totalLooperRound,
      totalOverLockRound,
      totalSheeringNeedleRound,
      totalTrimThreadRound
    })
  }

  createThread = (threadUpdted) => {
    let thread = {}
    thread.magnumStyleId = this.state.magnumStyleId
    thread.styleReferenceId = this.state.styleReferenceId
    thread.data = this.state.threadData
    thread.sampleDate = this.state.sampleDate
    thread.sampleType = this.state.sampleType
    thread.size = this.state.size
    thread.wash = this.state.wash
    thread.wastage = this.state.wastage
    thread.otherSizes = this.state.otherSizes
    thread.totalNeedle = this.state.totalNeedle
    thread.totalNeedleRound = this.state.totalNeedleRound
    thread.totalLooper = this.state.totalLooper
    thread.totalLooperRound = this.state.totalLooperRound
    // thread.sizes = this.state.sizes
    thread.chartPreparedBy = this.state.chartPreparedBy
    thread.chartPreparedOn = this.state.chartPreparedOn
    thread.customer = this.state.customer
    thread.customerDepartmentId = this.state.customerDepartmentId
    thread.smvId = this.state.smvId
    thread.allSizes = this.state.sizes

    thread.totalOverLock = this.state.totalOverLock
    thread.totalOverLockRound = this.state.totalOverLockRound
    thread.totalSheeringNeedle = this.state.totalSheeringNeedle
    thread.totalSheeringNeedleRound = this.state.totalSheeringNeedleRound
    thread.totalTrimThread = this.state.totalTrimThread
    thread.totalTrimThreadRound = this.state.totalTrimThreadRound
    thread.totalVal = this.state.totalVal

    if (this.state.threadId !== "") {
      thread._id = this.state.threadId
    }
    StyleServices.createThread(thread)
      .then(response => {
        if (response.status == 200) {
          if (threadUpdted)
            this.props.getalertMessage("success", response.text.message)
          this.setState({ threadCreated: true })

        }
      })
      .catch(error => this.props.getalertMessage("error", error.toString()))
  }

  // Thread func end
  /*****************************************************************************/

  openPrint = val => {
    let smvObData = JSON.parse(JSON.stringify(this.state.smvObData))
    this.setState(
      {
        smvObData,
        printLoading: true
      },
      () => {
        var divToPrint = document.getElementById(val)
        var newWin = window.open("", "mywindow")
        newWin.document.write(divToPrint.outerHTML)
        newWin.print()
        newWin.close()
      }
    )
  }

  openXL = () => {
    let smvObData = JSON.parse(JSON.stringify(this.state.smvObData))
    this.setState({
      smvObData,
      // threadCalculation,
      printLoading: true
    }, () => {

    }
    )
  }

  createDuplicate = () => {
    this.setState({
      threadCreated: false,
      styleReferenceId: null,
      sampleType: null,
      size: null,
      customerName: "",
      departmentName: "",
      customer: null,
      customerDepartmentId: null,
      magnumStyleName: "",
      magnumStyleId: null,
      allSizes: []
    })

    this.getMagnumStyleNo("")
    return this.createSMV(true)
  }

  //handle input values
  _handleInputChange = (name, value) => {

    this.setState({
      [name]: value,
    })
  }

  smvObPrintData = () => {
    let smvObData = {
      smv: [],
      threadCalculation: {
        threadCalculationArray: []
      }
    }

    const state = { ...this.state }
    let { smv } = smvObData


    if (!!this.state.styleReferenceId) {
      smvObData.styleReferenceId =
        this.state.styleNoInfo &&
        this.state.styleNoInfo.length > 0 &&
        this.state.styleNoInfo
          .map((data, index) => {
            if (data.value === this.state.styleReferenceId) {
              this.setState({ styleNo: data.label })
              return data.label
            }
          })
          .filter(Boolean)[0]
    }

    if (!!this.state.sampleType) {
      smvObData.sampleType =
        this.state.prefillInfo.SAMPLETYPE &&
        this.state.prefillInfo.SAMPLETYPE.length > 0 &&
        this.state.prefillInfo.SAMPLETYPE.map((data, index) => {
          if (data.value === this.state.sampleType) {
            this.setState({ sampleLabel: data.label })
            return data.label
          }
        }).filter(Boolean)[0]
    }

    smvObData.magnumStyleName = this.state.magnumStyleName
    smvObData.customerName = this.state.customerName
    smvObData.departmentName = this.state.departmentName
    smvObData.sampleDate = this.state.sampleDate
    smvObData.size = this.state.size
    smvObData.chartPreparedOn = this.state.chartPreparedOn
    smvObData.firstName = this.state.firstName
    smvObData.lastName = this.state.lastName
    var radios = this.state.allSizes;
    if (this.state.sizes)
      smvObData.selectedsize = radios.find((data, index) => data._id === this.state.sizes).size

    // smvObData.allSizes = this.state.sizes&&document.getElementById(this.state.sizes).checked

    if (this.state.smvdata && this.state.smvdata.length > 0) {
      this.state.smvdata.map((value, index) => {
        let Data = {}
        Data.index = index + 1

        Data.operations =
          this.state.prefillInfo.OPERATION &&
          this.state.prefillInfo.OPERATION.length > 0 &&
          this.state.prefillInfo.OPERATION.map((data, index) => {
            if (data.value === value.operations) {
              return data.label
            }
          }).filter(Boolean)[0]

        Data.machine =
          this.state.prefillInfo.MACHINE &&
          this.state.prefillInfo.MACHINE.length > 0 &&
          this.state.prefillInfo.MACHINE.map((data, index) => {
            if (data.value === value.machine) {
              return data.name
            }
          }).filter(Boolean)[0]

        Data.folder =
          this.state.prefillInfo["FOLDER/GUIDE"] &&
          this.state.prefillInfo["FOLDER/GUIDE"].length > 0 &&
          this.state.prefillInfo["FOLDER/GUIDE"]
            .map((data, index) => {
              if (data.value === value.folder) {
                return data.label
              }
            })
            .filter(Boolean)[0]

        Data.seconds = value.seconds
        Data.sam =
          value.SAM !== Number.POSITIVE_INFINITY ||
            value.SAM !== Number.NEGATIVE_INFINITY
            ? value.SAM
            : null
        Data.targetPerHour =
          value.SAM !== Number.POSITIVE_INFINITY ||
            value.targetPerHour !== Number.NEGATIVE_INFINITY
            ? Math.ceil(value.targetPerHour).toFixed(0)
            : null

        smvObData.smv.push(Data)
      })
    }

    smvObData.totalSam = Number(state.totalSam)
    smvObData.minutesPerDay = Number(state.minutesPerDay)
    smvObData.target100 = Math.ceil(state["100Target"])
    smvObData.target80 = Math.ceil(state["80Target"])

    setTimeout(
      () =>
        this.setState({
          smvObData
        }),
      500
    )

    // Thread Calculation Data
    let { threadCalculation } = smvObData

    let { threadCalculationArray } = threadCalculation

    if (this.state.threadData && this.state.threadData.length > 0) {
      this.state.threadData.map((value, index) => {
        let threadData = {}
        threadData.index = index + 1
        threadData.length = value.length
        threadData.factor = value.factor
        threadData.rating = value.rating
        threadData.rating = value.rating
        threadData.total = value.total
        threadData.needle = value.total * (Number(value.needle) / 100)
        threadData.looper = value.total * (Number(value.looper) / 100)
        threadData.overLock = value.total * (Number(value.overLock) / 100)
        threadData.trimThread = value.total * (Number(value.trimThread) / 100)
        threadData.sheeringNeedle =
          value.total * (Number(value.sheeringNeedle) / 100)

        threadData.machine =
          this.state.prefillInfo.MACHINE &&
          this.state.prefillInfo.MACHINE.length > 0 &&
          this.state.prefillInfo.MACHINE.map((data, index) => {
            if (data.value === value.machine) {
              return data.name
            }
          }).filter(Boolean)[0]

        threadData.operation =
          this.state.prefillInfo.OPERATION &&
          this.state.prefillInfo.OPERATION.length > 0 &&
          this.state.prefillInfo.OPERATION.map((data, index) => {
            if (data.value === value.operations) {
              return data.label
            }
          }).filter(Boolean)[0]

        threadData.thread =
          this.state.prefillInfo.THREAD &&
          this.state.prefillInfo.THREAD.length > 0 &&
          this.state.prefillInfo.THREAD.map((data, index) => {
            if (data.value === value.thread) {
              return data.label
            }
          }).filter(Boolean)[0]

        threadCalculationArray.push(threadData)
      })
    }
    threadCalculation.totalVal = this.state.totalVal
    threadCalculation.totalNeedle = this.state.totalNeedle
    threadCalculation.totalLooper = this.state.totalLooper
    threadCalculation.totalOverLock = this.state.totalOverLock
    threadCalculation.totalTrimThread = this.state.totalTrimThread
    threadCalculation.totalSheeringNeedle = this.state.totalSheeringNeedle

    threadCalculation.wastage = this.state.wastage
    threadCalculation.add =
      Number(this.state.wastage) +
      Number(this.state.otherSizes) +
      Number(this.state.wash)
    threadCalculation.otherSizes = this.state.otherSizes
    threadCalculation.totalNeedleRound = this.state.totalNeedleRound
    threadCalculation.wash = this.state.wash
    threadCalculation.totalLooperRound = this.state.totalLooperRound
    threadCalculation.totalOverLockRound = this.state.totalOverLockRound
    threadCalculation.totalTrimThreadRound = this.state.totalTrimThreadRound
    threadCalculation.totalSheeringNeedleRound = this.state.totalSheeringNeedleRound

    threadCalculation.allSizes = this.state.allSizes.length

    setTimeout(
      () =>
        this.setState({
          smvObData: {
            ...this.state.smvObData,
            smv,
            threadCalculation
            // threadCalculationArray
          }
        }),
      500
    )
  }

  confirmDuplicate = () => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className=" p-5 text-center">
            <h3>Do you want to create a duplicate SMV/OB and Thread Consumption?</h3>
            {/* <p>Are you sure you would like to Duplicate?</p> */}
            <button
              type="button"
              class="primary"
              style={{ width: "20%" }}
              onClick={onClose}
            >
              No
            </button>{" "}
            <button
              type="button"
              class="primary"
              style={{ width: "20%" }}
              onClick={() => {
                this.createDuplicate();
                onClose();
              }}
            >
              Yes
            </button>
          </div>
        );
      },
      closeOnClickOutside: true
    });
  };

  render() {

    const {
      active,
      smvNumber,
      styleReferenceId,
      magnumStyleName,
      customerName,
      departmentName,
      sampleDate,
      sampleType,
      chartPreparedOn,
      size,
      smvdata,
      minutesPerDay,
      totalSam,
      threadData,
      styleNo,
      sampleLabel,
      totalVal,
      totalNeedle,
      totalLooper,
      totalOverLock,
      totalTrimThread,
      totalSheeringNeedle,
      wastage,
      otherSizes,
      totalNeedleRound,
      wash,
      totalLooperRound,
      totalOverLockRound,
      totalTrimThreadRound,
      totalSheeringNeedleRound,
      allSizes,

    } = this.state
    const {
      threadCalculation,
      smv,
      firstName,
      lastName,
      target100,
      target80,
      threadCalculationArray,
      selectedsize
    } = this.state.smvObData

    let overlayApply = ""
    let opacityApply = "card-filter meeting-min-con "
    if (!this.state.readOnlyClass) {
      overlayApply = "overlay-apply"
      opacityApply += "opacity-apply"
    }


    return (
      <Fragment>
        {this.state.isLoading && <Loading />}
        <div class="right-section bg-white">
          <span className="btn-green-icon mr-3 pull-right download-xl"
            onClick={e => {
              this.handleActive()
              this.smvObPrintData()
              this.calcForTotal()
              setTimeout(() => this.openXL(), 500)

            }}>
            Download <i class="material-icons">
              keyboard_arrow_down
            </i>
            <div className={`Excel ${active ? 'active' : 'not-active ml-3'}`}>
              {this.state.printLoading && <ReactHTMLTableToExcel
                id="test-table-xls-button"
                className="download-table-xls-button"
                table="table-to-xls"
                filename="tablexls"
                sheet="tablexls"
                buttonText={<img id="xlSheet" src="https://cdn0.iconfinder.com/data/icons/document-file-types/512/xls-512.png" />}
                open={this.openXL} />
              }
            </div>
          </span>

          <span
            className="btn-green-icon mr-3 pull-right "
            onClick={e => {
              this.setState({ isLoading: true })
              setTimeout(() => {
                this.smvObPrintData()
                this.systemValues()
                this.setState({ isLoading: false })
                setTimeout(() => this.openPrint("printSmv_Ob"), 2000)
              }, 2000)
            }}
          >
            <img src={printer} />
          </span>




          <table id="table-to-xls" className="d-none">
            <div className="bold text-center p-1 ">
              <b>Create SMV/OB and Thread Consumption</b>
            </div>
            <div className="printrow bb-p">
              <div className="text-capitalize">

                <table >

                  <thead>
                    <tr>
                      <td className="label-text"><b>Style No</b></td>
                      <td className="label-text"><b>Style Name</b></td>
                      <td className="label-text"><b>Customer Name</b></td>
                    </tr>
                    <tr>


                      <td className="bold">{styleNo}</td>
                      <td className="bold">{magnumStyleName}</td>
                      <td className="bold">{`${customerName}/${departmentName}`}</td>
                    </tr>
                    <tr>
                      <th></th>
                      <th></th>
                      <th></th>
                    </tr>
                    <tr>
                      <td className="label-text"><b>Sample Type</b></td>
                      <td className="label-text"><b>Sample Date</b></td>
                      <td className="label-text"><b>Size</b></td>
                      <td className="label-text"><b>Chart Prepared On</b></td>
                      <td className="label-text"><b>Chart Prepared By</b></td>
                    </tr>
                    <tr>
                      <td className="bold">{sampleLabel}</td>
                      <td className="bold">
                        {moment(sampleDate).format("HH:mm DD MMM YYYY")}
                      </td>
                      <td className="bold">{size}</td>
                      <td className="bold">
                        {moment(chartPreparedOn).format("HH:mm DD MMM YYYY")}
                      </td>
                      <td className="bold">{`${firstName ? firstName : ''} ${lastName ? lastName : ''}`}</td>
                    </tr>

                  </thead>
                </table>
              </div>
            </div>

            <div className="printrow bb-p">
              <div className="text-capitalize">
                <table>
                  <tbody>
                    <tr>
                      <th></th>
                      <th></th>
                      <th></th>
                    </tr>

                    <tr>
                      <td className="label-text"><b>S.No</b></td>
                      <td className="label-text"><b>Operations </b></td>
                      <td className="label-text"><b>Machine</b></td>
                      <td className="label-text"><b>Folder/Guide</b></td>
                      <td className="label-text"><b>Seconds</b></td>
                      <td className="label-text"><b>SAM</b></td>
                      <td className="label-text"><b>Target Per Hour</b></td>
                    </tr>

                    {smv &&
                      smv.length > 0 &&
                      smv.map((value, index) => {
                        return (
                          <tr>
                            <td className="bold">{value.index}</td>
                            <td className="bold">{value.operations}</td>
                            <td className="bold">{value.machine}</td>
                            <td className="bold">{value.folder}</td>
                            <td className="bold">{value.seconds}</td>
                            <td className="bold">{value.sam}</td>
                            <td className="bold">{value.targetPerHour}</td>
                          </tr>
                        )
                      })}

                    <tr>
                      <td colspan="5" className="label-text text-right">
                        <b>Total SAM</b>
                      </td>
                      <td className="bold">{totalSam}</td>
                    </tr>
                    <tr>
                      <th></th>
                      <th></th>
                      <th></th>
                    </tr>
                    <tr>
                      <td colspan="2" className="label-text text-right">
                        <b>MINUTES PER DAY</b>
                      </td>
                      <td className="bold">{minutesPerDay}</td>
                    </tr>
                    <tr>
                      <td colspan="2" className="label-text text-right">
                        <b>100% TARGET</b>
                      </td>
                      <td className="bold">{target100}</td>
                      <td className="bold"><b>PCS PER TAILOR</b></td>
                    </tr>
                    <tr>
                      <td colspan="2" className="label-text text-right">
                        <b>80% TARGET</b>
                      </td>
                      <td className="bold">{target80}</td>
                      <td className="bold"><b>PCS PER TAILOR</b></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="printrow bb-p">
              <div className="text-capitalize">
                <p className="bold text-center"><b>Thread Consumption</b></p>

                <table className="w-100">
                  <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                  </tr>
                  <tbody>
                    <tr>
                      <td className="label-text"><b>S.No</b></td>
                      <td className="label-text"><b>Operations</b></td>
                      <td className="label-text"><b>Machine</b></td>
                      <td className="label-text"><b>Length</b></td>
                      <td className="label-text"><b>Factor</b></td>
                      <td className="label-text"><b>Rating</b></td>
                      <td className="label-text"><b>Total</b></td>
                      <td className="label-text"><b>Needle</b></td>
                      <td className="label-text"><b>Looper</b></td>
                      <td className="label-text"><b>Over Lock</b></td>
                      <td className="label-text"><b>TRD Elastic</b></td>
                      <td className="label-text"><b>Sheering Needle</b></td>
                    </tr>
                    {threadCalculation && threadCalculation.threadCalculationArray &&
                      threadCalculation.threadCalculationArray.length > 0 &&
                      threadCalculation.threadCalculationArray.map((value, index) => {
                        return (
                          <tr>
                            <td className="bold">{value.index}</td>
                            <td className="bold">{value.operation}</td>
                            <td className="bold">{value.machine}</td>
                            <td className="bold">{value.length}</td>
                            <td className="bold">{value.factor}</td>
                            <td className="bold">{value.rating}</td>
                            <td className="bold">
                              {Number(value.total).toFixed(2)}
                            </td>
                            <td className="bold">
                              {Number(value.needle).toFixed(2)}
                            </td>
                            <td className="bold">
                              {Number(value.looper).toFixed(2)}
                            </td>
                            <td className="bold">
                              {Number(value.overLock).toFixed(2)}
                            </td>
                            <td className="bold">
                              {Number(value.trimThread).toFixed(2)}
                            </td>
                            <td className="bold">
                              {Number(value.sheeringNeedle).toFixed(2)}
                            </td>
                          </tr>
                        )
                      })}

                    <tr>
                      <td colspan="6" className="label-text text-right ">
                        <b> Total:{" "}</b>
                      </td>
                      <td className="bold">{totalVal}</td>
                      <td className="bold">{totalNeedle}</td>
                      <td className="bold">{totalLooper}</td>
                      <td className="bold">{totalOverLock}</td>
                      <td className="bold">{totalTrimThread}</td>
                      <td className="bold">{totalSheeringNeedle}</td>
                    </tr>
                    <tr>
                      <th></th>
                      <th></th>
                      <th></th>
                    </tr>
                    <tr>
                      <td colspan="2" className="label-text text-right">
                        <b>Wastage</b>
                      </td>
                      <td className="bold">{wastage}%</td>
                      <td colspan="3"></td>
                      <td className="bold"></td>
                      <td className="bold"></td>
                      <td className="bold"></td>
                      <td className="bold"></td>
                      <td className="bold"></td>
                    </tr>
                    <tr>
                      <td colspan="2" className="label-text text-right">
                        <b>Other sizes</b>
                      </td>
                      <td className="bold">{otherSizes} %</td>
                    </tr>
                    <tr>
                      <td colspan="2" className="label-text text-right">
                        <b>Wash</b>
                      </td>
                      <td className="bold">{wash} %</td>
                      <td colspan="3"></td>
                      <td className="bold"></td>
                      <td className="bold"></td>
                      <td className="bold"></td>
                      <td className="bold"></td>
                      <td className="bold"></td>
                    </tr>
                    <tr>
                      <td colspan="7"></td>
                      <td className="label-text"><b>Needle</b></td>
                      <td className="label-text"><b>looper</b></td>
                      <td className="label-text"><b>Over lock</b></td>
                      <td className="label-text"><b>TRD Elastic</b></td>
                      <td className="label-text"><b>Sheering Needle</b></td>
                    </tr>
                    <tr>
                      <td colspan="2" className="label-text text-right">
                        <b>Add %</b>
                      </td>
                      <td className="bold">{wash + otherSizes + wastage}%</td>
                      <td
                        colspan="3"
                        className="label-text text-right padding-top-align"
                      >
                        <b> Total MTRS of REQD (Incl. Add%)</b>
                      </td>
                      <td className="bold"></td>
                      <td className="bold">{totalNeedleRound ? totalNeedleRound : ''}</td>
                      <td className="bold">{totalLooperRound}</td>
                      <td className="bold">{totalOverLockRound}</td>
                      <td className="bold">{totalTrimThreadRound}</td>
                      <td className="bold">{totalSheeringNeedleRound}</td>
                    </tr>

                    <tr>
                      <td><b>Size</b></td>
                      <td>{selectedsize}</td>

                    </tr>
                    <tr>
                      <td colspan="7"></td>
                      <td className="bold"></td>
                      <td className="bold"></td>
                      <td className="bold"></td>
                      <td className="bold"></td>
                    </tr>
                    <tr>
                      <td colspan="2" className="label-text text-right"></td>
                      <td className="bold"></td>
                      <td colspan="3"></td>

                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

          </table>


          <div class="row nopadding">
            <PageHeader
              header={this.state.header}
              history={this.props.history}
            />
            <div class="col-md-12">
              <div class="col-md-12 nopadding">
                {smvNumber && (
                  <div className="col-md-12">
                    <p>{smvNumber}</p>
                  </div>
                )}
                <div class="col-md-8 nopadding">
                  <div class="col-md-3">
                    <div class="form-group">
                      <label>Magnum Style No.</label>
                      <div class="custom-async-select">
                        <Async
                          name="styleReferenceId"
                          value={styleReferenceId}
                          onInputChange={value => this.getMagnumStyleNo(value)}
                          onChange={val => this.getStyleReferenceInfo(val)}
                          placeholder="Find Style"
                          options={this.state.styleNoInfo}
                          disabled={this.state.disabled}
                          onSelectResetsInput={false}
                          onBlurResetsInput={false}
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="name">Style Name</label>
                      <span>
                        <h6> {magnumStyleName}</h6>
                      </span>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="form-group">
                      <label for="name">Customer/Department name</label>
                      <span>
                        <h6>{`${customerName}-${departmentName}`}</h6>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12 nopadding">
                <div class="col-md-12 nopadding">
                  <div class="col-md-2 ">
                    <Field
                      isFormGroup={true}
                      inputType="select"
                      inputName="sampleType"
                      value={sampleType}
                      options={this.state.prefillInfo.SAMPLETYPE}
                      label={"Sample Type"}
                      onChange={this._handleInputChange}
                      disabled={this.state.disabled}
                    />
                  </div>
                  <div class="col-md-2">
                    <Field
                      isFormGroup={true}
                      inputType="date"
                      inputName="sampleDate"
                      label="Sample Date"
                      value={sampleDate}
                      onChange={this._handleInputChange}
                      disabled={this.state.disabled}
                    />
                  </div>
                  <div class="col-md-2">
                    <Field
                      isFormGroup={true}
                      inputType="text"
                      inputName="size"
                      label="Size"
                      value={size}
                      onChange={this._handleInputChange}
                      disabled={this.state.disabled}
                    />
                  </div>
                  <div class="col-md-3">
                    <Field
                      isFormGroup={true}
                      inputType="date"
                      inputName="chartPreparedOn"
                      label="Chart Prepared On"
                      value={chartPreparedOn}
                      onChange={this._handleInputChange}
                      disabled={this.state.disabled}
                    />
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="name">Chart Prepared By</label>
                      <p>{`${this.state.firstName} ${this.state.lastName}`}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12">
              <div class="col-md-12 thread-consumption-sec2 smv-sec2">
                <table class="lined bordered responsive-table">
                  <thead>
                    <tr>
                      <th width="5%">S. No</th>
                      <th width="20%">Operations</th>
                      <th width="20%">Machine</th>
                      <th width="20%">Folder / Guide </th>
                      <th width="10%">Seconds</th>
                      <th width="10%">SAM</th>
                      <th width="10%">Target Per Hour</th>
                      {/* <th width="5%">
                        {this.state.action != "view" && <ButtonIcon
                          buttonType="add"
                          addRemoveFunc={() => this.addSmv()}
                        />}
                      </th> */}
                    </tr>
                  </thead>

                  <tbody>
                    {smvdata.map((value, index) => {
                      return (
                        <tr
                          draggable
                          className="droppable"
                          onDrag={e => this._onDragStart(e, index)}
                          onDragOver={event => this._onDragOver(event)}
                          onDrop={e => this._onDropEnd(e, index)}
                          key={index}
                        >
                          <td>{index + 1}</td>
                          <td>
                            <Field
                              isFormGroup={false}
                              inputType="select"
                              inputName="operations"
                              value={value.operations}
                              options={this.state.prefillInfo.OPERATION}
                              index={index}
                              onChange={this.updateValueForRowdata}
                              disabled={this.state.disabled}
                            />
                          </td>
                          <td>
                            <Field
                              isFormGroup={false}
                              inputType="select"
                              inputName="machine"
                              value={value.machine}
                              options={this.state.prefillInfo.MACHINE}
                              index={index}
                              onChange={this.updateValueForRowdata}
                              disabled={this.state.disabled}
                            />
                          </td>
                          <td>
                            <Field
                              isFormGroup={false}
                              inputType="select"
                              inputName="folder"
                              value={value.folder}
                              options={this.state.prefillInfo["FOLDER/GUIDE"]}
                              index={index}
                              onChange={this.updateValueForRowdata}
                              disabled={this.state.disabled}
                            />
                          </td>
                          <td>
                            <Field
                              isFormGroup={false}
                              inputType="text"
                              inputName="seconds"
                              value={value.seconds}
                              index={index}
                              onChange={this.updateValueForRowdata}
                              disabled={this.state.disabled}
                            />
                          </td>
                          <td>
                            <Field
                              isFormGroup={false}
                              inputType="text"
                              inputName="SAM"
                              value={
                                value.SAM !== Number.POSITIVE_INFINITY ||
                                  value.SAM !== Number.NEGATIVE_INFINITY
                                  ? value.SAM
                                  : null
                              }
                              index={index}
                              onChange={this.updateValueForRowdata}
                              disabled={true}
                            />
                          </td>
                          <td>
                            <Field
                              isFormGroup={false}
                              inputType="text"
                              inputName="targetPerHour"
                              value={
                                value.SAM !== Number.POSITIVE_INFINITY ||
                                  value.targetPerHour !== Number.NEGATIVE_INFINITY
                                  ? Math.ceil(value.targetPerHour).toFixed(0)
                                  : null
                              }
                              index={index}
                              onChange={this.updateValueForRowdata}
                              disabled={true}
                            />
                          </td>
                          <td>
                            {this.state.action != "view" && (
                              <ButtonIcon
                                buttonType="clear"
                                addRemoveFunc={() => this.removeSmv(index)}
                              />
                            )}
                          </td>
                        </tr>
                      )
                    })}

                    <tr>
                      <td colspan="4" />
                      <td class="thread-label">Total Sam</td>
                      <td>
                        <input
                          type="number"
                          class="form-control customized-height-inputform"
                          value={totalSam}
                          disabled
                        />
                      </td>
                      <td />
                      <td>
                        {this.state.action != "view" && (
                          <ButtonIcon
                            buttonType="add"
                            addRemoveFunc={() => this.addSmv()}
                          />
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td />
                      <td class="thread-label">Minutes Per Day</td>
                      <td>
                        <input
                          type="text"
                          class="form-control customized-height-inputform"
                          name="minutesPerDay"
                          value={minutesPerDay}
                          onChange={e =>
                            this._handleInputChange(
                              e.target.name,
                              e.target.value
                            )
                          }
                          disabled={this.state.disabled}
                        />
                      </td>
                      <td />
                      <td colspan="3" />
                    </tr>
                    <tr>
                      <td />
                      <td class="thread-label">100% target</td>
                      <td>
                        <input
                          type="text"
                          class="form-control customized-height-inputform"
                          name="100Target"
                          value={Math.ceil(this.state["100Target"])}
                          onChange={e =>
                            this._handleInputChange(
                              e.target.name,
                              e.target.value
                            )
                          }
                          disabled={this.state.disabled}
                        />
                      </td>
                      <td class="thread-label text-left">pcs per tailor</td>
                      <td colspan="3" />
                    </tr>
                    <tr>
                      <td />
                      <td class="thread-label">80% target</td>
                      <td>
                        <input
                          type="text"
                          class="form-control customized-height-inputform"
                          name="80Target"
                          value={Math.ceil(this.state["80Target"])}
                          onChange={e =>
                            this._handleInputChange(
                              e.target.name,
                              e.target.value
                            )
                          }
                          disabled={this.state.disabled}
                        />
                      </td>
                      <td class="thread-label text-left">pcs per tailor</td>
                      <td colspan="3" />
                    </tr>
                  </tbody>
                </table>
              </div>
              {this.state.action != "view" && (
                <div class="col-md-12 profile-btn text-center">
                  <Button
                    buttonType="cancel"
                    buttonName={"cancel"}
                    history={this.props.history}
                  />
                  <Button
                    buttonType="save"
                    buttonName={"save"}
                    onClick={() => this.createSMV(false)}
                  />
                </div>
              )}
            </div>
            <Fragment>
              <div className="col-md-12 nopadding text-center">
                <h6 className="p-3">Thread consumption</h6>
              </div>
              <div class="col-md-12 nopadding">
                <div className={overlayApply} />
                <div className={opacityApply} style={{ marginBottom: "0.5%" }}>
                  <div class="col-md-12 product-form nopadding">
                    <div class="col-md-12 nopadding">
                      <div class="col-md-12 thread-consumption-sec2 smv-sec2">
                        <table
                          class="lined bordered responsive-table p-0"
                          width="100%"
                        >
                          <tr>
                            <th width="3%">S.No</th>
                            <th width="12%">Operations</th>
                            <th width="10%">Machine</th>
                            <th width="12%">Thread</th>
                            <th width="7%">Length</th>
                            <th width="7%">Factor</th>
                            <th width="6%">Rating</th>
                            <th width="9%">Total</th>
                            <th width="8%">Needle</th>
                            <th width="8%">Looper</th>
                            <th width="8%">over Lock</th>
                            <th width="8%">TRD Elastic</th>
                            <th width="8%">Sheering needle</th>
                          </tr>
                          {threadData.map((value, index) => (
                            <tr>
                              <td>{index + 1}</td>
                              <td>
                                <Field
                                  isFormGroup={false}
                                  inputType="select"
                                  inputName="operations"
                                  value={value.operations}
                                  options={this.state.prefillInfo.OPERATION}
                                  index={index}
                                  // onChange={this.updateValuesforThreadCons}
                                  disabled={true}
                                />
                              </td>
                              <td>
                                <Field
                                  isFormGroup={false}
                                  inputType="select"
                                  inputName="machine"
                                  value={value.machine}
                                  options={this.state.prefillInfo.MACHINE}
                                  index={index}
                                  // onChange={this.updateValuesforThreadCons}
                                  disabled={true}
                                />
                              </td>
                              <td>
                                <Field
                                  isFormGroup={false}
                                  inputType="select"
                                  inputName="thread"
                                  value={value.thread}
                                  options={this.state.prefillInfo.THREAD}
                                  index={index}
                                  onChange={this.updateValuesforThreadCons}
                                  disabled={false}
                                />
                              </td>
                              <td>
                                <Field
                                  isFormGroup={false}
                                  inputType="number"
                                  inputName="length"
                                  style={{ textAlign: "center" }}
                                  value={value.length}
                                  index={index}
                                  onChange={this.updateValuesforThreadCons}
                                  disabled={this.state.disabled}
                                />
                              </td>
                              <td>
                                <Field
                                  isFormGroup={false}
                                  inputType="number"
                                  inputName="factor"
                                  style={{ textAlign: "center" }}
                                  value={value.factor}
                                  index={index}
                                  onChange={this.updateValuesforThreadCons}
                                  disabled={this.state.disabled}
                                />
                              </td>
                              <td>
                                <Field
                                  isFormGroup={false}
                                  inputType="number"
                                  inputName="rating"
                                  style={{ textAlign: "center" }}
                                  value={value.rating}
                                  index={index}
                                  onChange={this.updateValuesforThreadCons}
                                  disabled={this.state.disabled}
                                />
                              </td>
                              <td>
                                <Field
                                  isFormGroup={false}
                                  inputType="number"
                                  inputName="total"
                                  style={{ textAlign: "center" }}
                                  value={value.total}
                                  index={index}
                                  onChange={this.updateValuesforThreadCons}
                                  disabled={this.state.disabled}
                                />
                              </td>
                              <td>
                                <Field
                                  isFormGroup={false}
                                  inputType="number"
                                  inputName="needle"
                                  style={{ textAlign: "center" }}
                                  value={Number(
                                    value.total * (Number(value.needle) / 100)
                                  ).toFixed(2)}
                                  index={index}
                                  onChange={this.updateValuesforThreadCons}
                                  disabled={this.state.disabled}
                                />
                              </td>
                              <td>
                                <Field
                                  isFormGroup={false}
                                  inputType="number"
                                  inputName="looper"
                                  style={{ textAlign: "center" }}
                                  value={Number(
                                    value.total * (Number(value.looper) / 100)
                                  ).toFixed(2)}
                                  index={index}
                                  onChange={this.updateValuesforThreadCons}
                                  disabled={this.state.disabled}
                                />
                              </td>
                              <td>
                                <Field
                                  isFormGroup={false}
                                  inputType="number"
                                  inputName="overLock"
                                  style={{ textAlign: "center" }}
                                  value={Number(
                                    value.total * (Number(value.overLock) / 100)
                                  ).toFixed(2)}
                                  index={index}
                                  onChange={this.updateValuesforThreadCons}
                                  disabled={this.state.disabled}
                                />
                              </td>
                              <td>
                                <Field
                                  isFormGroup={false}
                                  inputType="text"
                                  inputName="trimThread"
                                  style={{ textAlign: "center" }}
                                  value={Number(
                                    value.total *
                                    (Number(value.trimThread) / 100)
                                  ).toFixed(2)}
                                  index={index}
                                  onChange={this.updateValuesforThreadCons}
                                  disabled={this.state.disabled}
                                />
                              </td>
                              <td>
                                <Field
                                  isFormGroup={false}
                                  inputType="text"
                                  inputName="sheeringNeedle"
                                  style={{ textAlign: "center" }}
                                  value={Number(
                                    value.total *
                                    (Number(value.sheeringNeedle) / 100)
                                  ).toFixed(2)}
                                  index={index}
                                  onChange={this.updateValuesforThreadCons}
                                  disabled={this.state.disabled}
                                />
                              </td>
                            </tr>
                          ))}
                          <tr>
                            <td colspan="6" />
                            <td> </td>
                            <td style={{ textAlign: "center" }}>
                              {Number(totalVal).toFixed(2)}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {Number(totalNeedle).toFixed(2)}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {Number(totalLooper).toFixed(2)}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {Number(totalOverLock).toFixed(2)}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {Number(totalTrimThread).toFixed(2)}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {Number(totalSheeringNeedle).toFixed(
                                2
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td colSpan="2"></td>
                            <td class="thread-label">Wastage</td>
                            <td>{this.state.wastage + " %"}</td>
                            <td class="thread-label"></td>
                            <td></td>
                            <td className="thread-label">Add</td>
                            <td>
                              {Number(this.state.wastage) +
                                Number(this.state.otherSizes) +
                                Number(this.state.wash) +
                                " % "}
                            </td>
                            <td colSpan="4"></td>
                          </tr>
                          <tr>
                            <td colSpan="2"></td>
                            <td class="thread-label">Other Sizes</td>
                            <td>{this.state.otherSizes + " %"}</td>
                            <td class="thread-label"> </td>
                            <td></td>
                            <td className="thread-label">Needle</td>
                            <td>{this.state.totalNeedleRound}</td>
                            <td class="thread-label">  </td>
                            <td colSpan="4"></td>
                          </tr>
                          <tr>
                            <td colSpan="2"></td>
                            <td class="thread-label">wash</td>
                            <td>{this.state.wash + " %"}</td>
                            <td class="thread-label"></td>
                            <td></td>
                            <td className="thread-label">Looper</td>
                            <td>{this.state.totalLooperRound}</td>
                            <td colSpan="4"></td>
                          </tr>
                          <tr>
                            <td colspan="6" />
                            <td className="thread-label">O/L</td>
                            <td>{this.state.totalOverLockRound}</td>
                            <td colSpan="4"></td>
                          </tr>
                          <tr>
                            <td colspan="6" />
                            <td className="thread-label">TRD ELASTIC</td>
                            <td>{this.state.totalTrimThreadRound}</td>
                            <td colSpan="4"></td>
                          </tr>
                          <tr>
                            <td colspan="6" />
                            <td className="thread-label">
                              SHEERING NEEDLE TRD
                            </td>
                            <td>{this.state.totalSheeringNeedleRound}</td>
                            <td colSpan="4"></td>
                          </tr>

                        </table>
                      </div>
                      <div className="col-md-6 col-md-offset-3">
                        <table className="table-bordered">
                          <tbody>
                            <tr>
                              <td colSpan={this.state.allSizes.length}>
                                Sizes
                              </td>
                            </tr>
                            <tr>
                              {this.state.allSizes.map((data, index) => {
                                return (
                                  <td>
                                    <p className="radio-inline nopadding">
                                      <input
                                        name="group"
                                        type="radio"
                                        className="filled-in-size hide-all"
                                        id={data._id}
                                        value={data._id}
                                        checked={this.state.sizes === data._id}
                                        onChange={(name, value) =>
                                          this._handleInputChange(
                                            "sizes",
                                            data._id
                                          )
                                        }
                                      />
                                      <label for={data._id} />
                                    </p>
                                    <label>{data.size}</label>
                                  </td>
                                )
                              })}
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      {this.state.action != "view" && (
                        <div class="col-md-12 profile-btn text-center">
                          <Button
                            buttonType="cancel"
                            buttonName="cancel"
                            history={this.props.history}
                          />
                          <Button
                            buttonName="save"
                            onClick={() => this.createThread(true)}
                          />
                          {this.state.threadId && (
                            <Button
                              buttonName="Duplicate"
                              onClick={this.confirmDuplicate}
                            />
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </Fragment>
          </div>
        </div>
        <div id="printSmv_Ob" className="d-none">
          {this.state.printLoading && (
            <PrintSmv smvObData={this.state.smvObData} />
          )}
        </div>
      </Fragment>
    )
  }
}
const mapStateToProps = state => {
  return {
    chartPreparedBy: state.main._id,
    firstName: state.main.firstName,
    lastName: state.main.lastName
  }
}

export default connect(
  mapStateToProps,
  null
)(SmvThread)


// WEBPACK FOOTER //
// ./src/pages/SmvThread/page.js